import { Route, Navigate, useParams } from 'react-router-dom';
import * as urls from 'routes/config';
import { configure, home } from 'routes/config';

import Configure from 'pages/Business/Agent/Configure';
import Identity from 'pages/Business/Agent/Configure/Identity';
import Knowledge from 'pages/Business/Agent/Configure/Knowledge';
import KnowledgeBaseForm from 'pages/Business/Setting/KnowledgeBase/components/KnowledgeBaseForm';
import KnowledgeDataSetForm from 'pages/Business/Setting/DataSet/Components/DataSetForm';
import KnowledgeForm from 'pages/Business/Agent/Configure/Knowledge/components/KnowledgeForm';
import QaChunkForm from 'pages/Business/Agent/Configure/QaChunk/Components/QaChunkForm';
import DeployWeb from 'pages/Business/Agent/Configure/DeployWeb';
import PersonalizedLink from 'pages/Business/Agent/Configure/PersonalizedLink';
import WebUrlForm from 'pages/Business/Agent/Configure/Knowledge/components/WebUrlForm';
import AgentDataSetForm from 'pages/Business/Agent/Configure/Knowledge/components/AgentDataSetForm';
import WebUrlSettingForm from 'pages/Business/Setting/DataSet/Components/WebUrlForm';
import Chunks from '@/pages/Business/Setting/Chunks';
import ChunkForm from '@/pages/Business/Setting/Chunks/Components/ChunkForm';

function promptTreePath(locationId?: string, agentId?: string) {
  return `${urls.agentBase(locationId, agentId)}/${urls.home.configure}/${urls.configure.behavior}/${urls.behavior.instructions}/prompt-tree`;
}

function RedirectToPromptTree() {
  const { locationId, agentId } = useParams();
  return <Navigate to={promptTreePath(locationId, agentId)} replace />;
}

export const configureRoutes = (
  <Route path={home.configure} element={<Configure />}>
    <Route index element={<Navigate to={configure.identity} replace />} />
    <Route path={configure.identity} element={<Identity />} />
    <Route path={configure.knowledge} element={<Knowledge />}>
      <Route path='add' element={<KnowledgeBaseForm />} />
      <Route path='add-website' element={<WebUrlForm />} />
      <Route path='add-document' element={<AgentDataSetForm />} />
      <Route path=':datasetId/edit-website' element={<WebUrlForm />} />
      <Route path=':datasetId/edit-document' element={<AgentDataSetForm />} />
      <Route path=':knowledgeBaseId/edit' element={<KnowledgeBaseForm />} />
      <Route path=':knowledgeBaseId/dataset' element={<KnowledgeForm />} />
      <Route path=':knowledgeBaseId/dataset/add' element={<KnowledgeDataSetForm />} />
      <Route path=':knowledgeBaseId/dataset/add-website' element={<WebUrlForm />} />
      <Route path=':knowledgeBaseId/dataset/:datasetId/edit' element={<KnowledgeDataSetForm />} />
      <Route path=':knowledgeBaseId/dataset/:datasetId/edit-website' element={<WebUrlSettingForm />} />
      <Route path='qa-chunk/add' element={<QaChunkForm />} />
      <Route path='qa-chunk/:chunkId/edit' element={<QaChunkForm />} />
      <Route path={`:knowledgeBaseId/dataset/${configure.chunks()}`} element={<Chunks />}>
        <Route path='add' element={<ChunkForm />} />
        <Route path=':chunkId/edit' element={<ChunkForm />} />
      </Route>
    </Route>
    {/* Legacy Behavior tab UI → PromptBuilder (explicit paths; do not catch prompt-tree) */}
    <Route path={configure.behavior} element={<RedirectToPromptTree />} />
    <Route path={`${configure.behavior}/instructions`} element={<RedirectToPromptTree />} />
    <Route path={`${configure.behavior}/global-actions/*`} element={<RedirectToPromptTree />} />
    <Route path={`${configure.behavior}/advance-settings`} element={<RedirectToPromptTree />} />
    <Route
      path={configure.deployPhone}
      element={<Navigate to={`${urls.business.base}/${urls.business.telephony}/numbers`} replace />}
    />
    <Route path={configure.deployWeb} element={<DeployWeb />} />
    <Route
      path={configure.connectSms}
      element={<Navigate to={`${urls.business.base}/${urls.business.telephony}/numbers`} replace />}
    />
    <Route path={configure.personalizeLink} element={<PersonalizedLink />} />
  </Route>
);
